<template>
    <!-- <b-container fluid > -->
     <div>
        <section-banner class="section-banner-general"></section-banner>
        <section-gox-born :content="content_gox"/>
        <section-team :content="content_team"/>
        <!-- <section-team-photo :content="content_team_photo"/> -->
    </div> 
    <!-- </b-container> -->
</template>
<script>
    import SectionTeam from '@/components/we/section-team'
    import SectionGoxBorn from '@/components/we/section-gox-born'
    import SectionBanner from '@/components/we/section-banner'
    // import SectionTeamPhoto from '@/components/we/section-team-photo'

    export default {
        name: 'We',
        components: {
            SectionTeam, SectionGoxBorn,SectionBanner
        },
        data: () => ({
           
            content_gox : {
                titulo: '¿Cómo nace <strong>GOX?</strong>',
                content: '<strong>GOX</strong> nace como una solución para afianzar y consolidar las relaciones entre los negocios tradicionales y sus clientes. <br><br>' +
                '¿Has sentido alguna vez un trato especial por ser cliente fiel? ¿Has recibido premios por tu fidelidad? Actualmente, los negocios tradicionales no tienen los recursos para generar y mantener este sentimiento de pertencia en sus clientes.' +
                '<br><br>La tecnología nos permite la transformación digital de estos negocios y ofrece los medios para lograr una relación duradera con sus clientes, y lo mejor... <strong> ¡de una manera muy sencilla!. </strong>',
                imagen: 'gox.png'
            },
             content_team : {
                titulo: 'Conoce a nuestro equipo',
                content: '<strong>¡En GOX sumamos a todos!</strong> Somos un equipo de alto nivel especializado en Fidelización donde cada uno da lo mejor de Sí, apoyándonos y manteniéndonos siempre a la vanguardia para lograr y mantener el vínculo de nuestros socios comerciales con sus clientes. <br><br>¡Nuestros logros están basados en alcanzar tu éxito!</strong>',
                imagen: 'team.png'
            },
            content_team_photo : {
                titulo: 'Nuestro <br>equipo',
            }
        }),
        methods: {}
    }
</script>
<style scoped>



@media (max-width: 600px) {
    .section-banner-general{
        display: none !important;
    }
}

</style>